<template>
  <common-template>
    <main class="settings">
      <b-container fluid>
        <h1 class="page-title">{{ $t(pageTitle) }}</h1>
        <section class="settings-category">
          <b-container fluid>
            <h2 class="settings-category-title">
              {{ $t('カスタマイズ設定') }}
            </h2>
            <b-row cols="1" cols-lg="3" class="settings-category-row">
              <b-col xs="12" lg="3" class="settings-category-col">
                <h3 class="settings-category-item-title">
                  <b-button :href="$appConfig.ScreenUrl.companyTranslation">
                    {{ $t('文言カスタマイズ') }}
                  </b-button>
                </h3>
                <p>
                  {{
                    $t(
                      'サービス内の標準文言をお客様任意の文言へ変更することができます。',
                    )
                  }}
                </p>
              </b-col>
              <b-col
                v-if="isUseSmallLot"
                xs="12"
                lg="3"
                class="settings-category-col"
              >
                <h3 class="settings-category-item-title">
                  <b-button
                    :href="`${$appConfig.ScreenUrl.customForm}?type=project`"
                  >
                    {{ $t('案件情報レイアウト') }}
                  </b-button>
                </h3>
                <p>
                  {{
                    $t(
                      '案件登録の入力項目を任意で選択及び並び替えをすることができます。',
                    )
                  }}
                </p>
              </b-col>
              <b-col
                v-if="isUseSmallLot"
                xs="12"
                lg="3"
                class="settings-category-col"
              >
                <h3 class="settings-category-item-title">
                  <b-button
                    :href="`${$appConfig.ScreenUrl.customForm}?type=workOrder`"
                  >
                    {{ $t('作業指示レイアウト') }}
                  </b-button>
                </h3>
                <p>
                  {{
                    $t(
                      '作業指示（案件詳細）の表示項目を任意で選択及び並び替えをすることができます。',
                    )
                  }}
                </p>
              </b-col>
            </b-row>
          </b-container>
        </section>

        <section class="settings-category">
          <b-container fluid>
            <h2 class="settings-category-title">{{ $t('基本情報設定') }}</h2>
            <b-row cols="1" cols-lg="4" class="settings-category-row">
              <b-col xs="12" lg="3" class="settings-category-col">
                <h3 class="settings-category-item-title">
                  <b-button :href="$appConfig.ScreenUrl.company">{{
                    $t('会社')
                  }}</b-button>
                </h3>
                <p>
                  {{
                    $t('会社の定時/稼働時間、休日設定等の基本設定を行います。')
                  }}
                </p>
              </b-col>
              <b-col xs="12" lg="3" class="settings-category-col">
                <h3 class="settings-category-item-title">
                  <b-button :href="$appConfig.ScreenUrl.factory">工場</b-button>
                </h3>
                <p>
                  {{
                    $t(
                      '任意で工場情報の登録及び工場の定時/稼働時間、休日設定等の基本設定を行います。',
                    )
                  }}
                </p>
              </b-col>
              <b-col xs="12" lg="3" class="settings-category-col">
                <h3 class="settings-category-item-title">
                  <b-button :href="$appConfig.ScreenUrl.department">
                    {{ $t('部署') }}
                  </b-button>
                </h3>
                <p>
                  {{
                    $t(
                      '任意で部署情報の登録及び部署の定時/稼働時間、休日設定等の基本設定を行います。',
                    )
                  }}
                </p>
              </b-col>
              <b-col
                v-if="isUseInventory"
                xs="12"
                lg="3"
                class="settings-category-col"
              >
                <h3 class="settings-category-item-title">
                  <b-button :href="$appConfig.ScreenUrl.space">
                    {{ $t('置き場') }}
                  </b-button>
                </h3>
                <p>
                  {{ $t('任意で置き場情報の登録を行います。') }}
                </p>
              </b-col>
              <b-col
                v-if="isUseInventory"
                xs="12"
                lg="3"
                class="settings-category-col"
              >
                <h3 class="settings-category-item-title">
                  <b-button :href="$appConfig.ScreenUrl.box">
                    {{ $t('棚番') }}
                  </b-button>
                </h3>
                <p>
                  {{ $t('任意で棚番情報の登録を行います。') }}
                </p>
              </b-col>
              <b-col xs="12" lg="3" class="settings-category-col">
                <h3 class="settings-category-item-title">
                  <b-button :href="$appConfig.ScreenUrl.partner">{{
                    $t('取引先')
                  }}</b-button>
                </h3>
                <p>{{ $t('得意先、仕入先の登録を行います。') }}</p>
              </b-col>
            </b-row>
            <b-row cols="1" cols-lg="3" class="settings-category-row">
              <b-col xs="12" lg="3" class="settings-category-col">
                <h3 class="settings-category-item-title">
                  <b-button :href="$appConfig.ScreenUrl.facility">{{
                    $t('工程')
                  }}</b-button>
                </h3>
                <p>
                  {{
                    $t(
                      '管理する工程（設備）の登録を行います。担当者との紐付けも行えます。',
                    )
                  }}
                </p>
              </b-col>
              <b-col xs="12" lg="3" class="settings-category-col">
                <h3 class="settings-category-item-title">
                  <b-button :href="$appConfig.ScreenUrl.user">{{
                    $t('担当者')
                  }}</b-button>
                </h3>
                <p>
                  {{
                    $t(
                      'ご利用及び管理を行う担当者の登録を行います。工程との紐付けも行えます。',
                    )
                  }}
                </p>
              </b-col>
              <b-col
                v-if="isUseSmallLot"
                xs="12"
                lg="3"
                class="settings-category-col"
              >
                <h3 class="settings-category-item-title">
                  <b-button :href="$appConfig.ScreenUrl.boardInHouse">
                    {{ $t('工程ボード') }}
                  </b-button>
                </h3>
                <p>
                  {{ $t('工程と担当者の紐付けの登録及び確認を行います。') }}
                </p>
              </b-col>
            </b-row>
            <b-row cols="1" cols-lg="1" class="settings-category-row">
              <b-col xs="12" lg="3" class="settings-category-col">
                <h3 class="settings-category-item-title">
                  <b-button :href="$appConfig.ScreenUrl.product">{{
                    $t('製品')
                  }}</b-button>
                </h3>
                <p>{{ $t('製品情報の登録及び管理を行います。') }}</p>
              </b-col>
            </b-row>
          </b-container>
        </section>

        <section class="settings-category">
          <b-container fluid>
            <h2 class="settings-category-title">{{ $t('CSV取込設定') }}</h2>
            <p>
              {{
                $t(
                  'ものレボ外サービスやツールで保有されている情報をCSVファイルを用いて一括で取込むための設定です。',
                )
              }}
            </p>
            <b-row cols="1" cols-lg="4" class="settings-category-row">
              <b-col xs="12" lg="3" class="settings-category-col">
                <h3 class="settings-category-item-title">
                  <b-button :href="$appConfig.ScreenUrl.productImport">
                    {{ $t('製品') }}
                  </b-button>
                </h3>
                <p>
                  {{
                    $t('製品情報を一括で登録するための取込み設定を行います。')
                  }}
                </p>
              </b-col>
              <b-col xs="12" lg="3" class="settings-category-col">
                <h3 class="settings-category-item-title">
                  <b-button :href="$appConfig.ScreenUrl.productProcessImport">
                    {{ $t('製品工程') }}
                  </b-button>
                </h3>
                <p>
                  {{
                    $t(
                      '登録されている製品へ工程情報を一括で登録するための取込み設定を行います。',
                    )
                  }}
                </p>
              </b-col>
              <b-col
                v-if="!isUseSmallLot || isUseInventory || isUsePurchase"
                xs="12"
                lg="3"
                class="settings-category-col"
              >
                <h3 class="settings-category-item-title">
                  <b-button :href="$appConfig.ScreenUrl.structureImport">
                    {{ $t('構成部品') }}
                  </b-button>
                </h3>
                <p>
                  {{
                    $t(
                      '登録されている製品情報の構成部品設定を一括で行うための取込み設定を行います。',
                    )
                  }}
                </p>
              </b-col>
              <b-col
                v-if="isUseInventory"
                xs="12"
                lg="3"
                class="settings-category-col"
              >
                <h3 class="settings-category-item-title">
                  <b-button :href="$appConfig.ScreenUrl.inventoryImport">
                    {{ $t('製品置場') }}
                  </b-button>
                </h3>
                <p>
                  {{
                    $t(
                      '登録されている製品への置場情報を一括で登録するための取込み設定を行います。',
                    )
                  }}
                </p>
              </b-col>
            </b-row>
            <b-row cols="1" cols-lg="4" class="settings-category-row">
              <b-col
                v-if="isUseSmallLot"
                xs="12"
                lg="3"
                class="settings-category-col"
              >
                <h3 class="settings-category-item-title">
                  <b-button :href="$appConfig.ScreenUrl.projectImport">
                    {{ $t('案件') }}
                  </b-button>
                </h3>
                <p>
                  {{
                    $t(
                      '工程管理の案件登録を一括で行うための取込み設定を行います。',
                    )
                  }}
                </p>
              </b-col>
              <b-col
                v-if="isUsePurchase"
                xs="12"
                lg="3"
                class="settings-category-col"
              >
                <h3 class="settings-category-item-title">
                  <b-button :href="$appConfig.ScreenUrl.orderImport">
                    {{ $t('受注') }}
                  </b-button>
                </h3>
                <p>
                  {{
                    $t(
                      '受発注管理の見積/受注登録を一括で行うための取込み設定を行います。',
                    )
                  }}
                </p>
              </b-col>
              <b-col
                v-if="!isUsePurchase && isUseInventory"
                xs="12"
                lg="3"
                class="settings-category-col"
              >
                <h3 class="settings-category-item-title">
                  <b-button :href="$appConfig.ScreenUrl.shipImport">
                    {{ $t('出庫計画') }}
                  </b-button>
                </h3>
                <p>
                  {{
                    $t('在庫管理の出庫計画を一括で取込むための設定を行います。')
                  }}
                </p>
              </b-col>
              <b-col
                v-if="!isUsePurchase && isUseInventory"
                xs="12"
                lg="3"
                class="settings-category-col"
              >
                <h3 class="settings-category-item-title">
                  <b-button :href="$appConfig.ScreenUrl.shipDeliverImport">
                    {{ $t('出庫実績') }}
                  </b-button>
                </h3>
                <p>
                  {{
                    $t(
                      '在庫管理の出庫実績を一括で登録するための取込み設定を行います。',
                    )
                  }}
                </p>
              </b-col>
            </b-row>
            <b-row cols="1" cols-lg="3" class="settings-category-row">
              <b-col
                v-if="!isUsePurchase && isUseInventory"
                xs="12"
                lg="3"
                class="settings-category-col"
              >
                <h3 class="settings-category-item-title">
                  <b-button :href="$appConfig.ScreenUrl.supplyExtraImport">
                    {{ $t('入庫計画') }}
                  </b-button>
                </h3>
                <p>
                  {{
                    $t('在庫管理の入庫計画を一括で取込むための設定を行います。')
                  }}
                </p>
              </b-col>
              <b-col
                v-if="!isUsePurchase && isUseInventory"
                xs="12"
                lg="3"
                class="settings-category-col"
              >
                <h3 class="settings-category-item-title">
                  <b-button :href="$appConfig.ScreenUrl.supplyDeliverImport">
                    {{ $t('入庫実績') }}
                  </b-button>
                </h3>
                <p>
                  {{
                    $t('在庫管理の入庫実績を一括で取込むための設定を行います。')
                  }}
                </p>
              </b-col>
              <b-col
                v-if="!isUsePurchase && isUseInventory"
                xs="12"
                lg="3"
                class="settings-category-col"
              >
                <h3 class="settings-category-item-title">
                  <b-button :href="$appConfig.ScreenUrl.lotImport">
                    {{ $t('棚卸在庫') }}
                  </b-button>
                </h3>
                <p>
                  {{
                    $t('在庫管理の棚卸在庫を一括で取込むための設定を行います。')
                  }}
                </p>
              </b-col>
              <b-col xs="12" lg="3" class="settings-category-col">
                <h3 class="settings-category-item-title">
                  <b-button :href="$appConfig.ScreenUrl.partnerImport">{{
                    $t('取引先')
                  }}</b-button>
                </h3>
                <p>
                  {{
                    $t('取引先情報を一括で登録するための取込み設定を行います。')
                  }}
                </p>
              </b-col>
            </b-row>
          </b-container>
        </section>
      </b-container>
    </main>
  </common-template>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      pageTitle: '各種設定',
      master: {},
    }
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
      userdata: 'auth/userdata',
    }),
    /** 受発注管理サービスを表示する権限があるか。 */
    isUsePurchase() {
      return this.master?.company?.isUsePurchase || false
    },
    /** 在庫管理サービスを表示する権限があるか。 */
    isUseInventory() {
      return this.master?.company?.isUseInventory || false
    },
    /** 工程管理サービスを表示する権限があるか。 */
    isUseSmallLot() {
      return this.master?.company?.isUseSmallLot || false
    },
  },
  components: {},
  updated() {
    document.title = this.$t(this.pageTitle)
  },
  async created() {
    this.master = await this.getMasterData()
  },
  methods: {
    /** DBマスタデータを取得する。 */
    async getMasterData() {
      const res = await this.$axios.get(
        `${this.$appConfig.CommonApiUrl}/masters`,
        {
          headers: {
            Authorization: this.authorization ? this.authorization : null,
          },
        },
      )
      return res.data
    },
  },
}
</script>

<style lang="scss" scoped>
.page-title {
  font-style: normal;
  font-weight: bold;
  font-size: 2.4rem;
  margin-bottom: 2rem;
  border-bottom: 1px solid #dee2e6;
  line-height: 2;
}

.settings {
  margin-top: 20px;

  &-category {
    margin-bottom: 4rem;

    &-title {
      font-style: normal;
      font-weight: bold;
      font-size: 2rem;
      line-height: 2;
      color: #003449;
    }

    &-row {
      @include lg {
        margin-bottom: 1rem;
      }
    }
    &-col {
      margin: 0.5rem 0rem 1rem 0rem;
    }

    &-item-title {
      margin: 1rem 0;

      .btn {
        padding: 0.8rem 4rem 0.8rem 1.7rem;
        border-radius: 5px;

        font-style: normal;
        font-weight: normal;
        font-size: 1.4rem;
        line-height: 1.8;
        letter-spacing: 0rem;
        color: #fff;
        white-space: nowrap;

        transition: opacity 0.3s, background-color 0.3s;
        background-color: #818181;
        &:hover {
          opacity: 0.8;
        }

        // 右端に矢印を表示する。
        position: relative;
        display: inline-block;
        &::after {
          width: 8px;
          height: 8px;

          content: '';
          border: 0px;
          border-top: solid 2px #fff;
          border-right: solid 2px #fff;
          -ms-transform: rotate(45deg);
          -webkit-transform: rotate(45deg);
          transform: rotate(45deg);

          position: absolute;
          top: 50%;
          right: 15px;
          margin-top: -4px;
          @media screen and (max-width: 768px) {
            right: 14px;
          }
        }
      }
    }
  }
}
</style>
